var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccUtilityService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Utility_service",
    "data-name": "Utility service",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8386",
    "data-name": "Rectangle 8386",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35238",
    "data-name": "Group 35238",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35884",
    "data-name": "Path 35884",
    d: "M5.883,2.915V24.039a.951.951,0,0,0,.567.921,1.11,1.11,0,0,0,1.134-.142l1.7-1.488,1.7,1.488a.983.983,0,0,0,1.347,0l1.7-1.488,1.7,1.488a.983.983,0,0,0,1.347,0l1.7-1.488,1.7,1.488a.859.859,0,0,0,1.063.142,1.023,1.023,0,0,0,.567-.921V2.915ZM18.927,13.4v.713H9.286V12.7h.6l.017-.005a.632.632,0,0,1,.087,0h8.223c.009,0,.016.005.025.005h.684v.7M9.283,9.293c0-.007,0-.014,0-.021V8.586h.627a.521.521,0,0,1,.079,0h8.935V10H9.286v-.7l0-.014m9.644,8.934H9.286V16.809h9.641v1.418Z",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccUtilityService);
export default __webpack_public_path__ + "static/media/mcc_utilityService.92241551b1f670dd3fb5ca5316d1ff51.svg";
export { ForwardRef as ReactComponent };